import { unitService } from '@/services/unit';
import { useAppSelector } from '@/store';
import { authSelector } from '@/store/reducers/auth';
import { UnitsProgress } from '@/types/progress';
import commonUtils from '@/utils/common';
import { useEffect, useState } from 'react';

const UseMyProfile = () => {
  const { user } = useAppSelector(authSelector);

  const [isLoading, setIsLoading] = useState(false);
  const [unitsProgress, setUnitsProgress] = useState<UnitsProgress | null>(null);
  const [isLevelComplete, setIsLevelComplete] = useState(false);

  const fetchStudentProfileProgress = async () => {
    if (user?.id) {
      setIsLoading(true);
      try {
        const response = (await unitService.fetchStudentProfile(user?.id))?.data;
        if (response) {
          const units = response.data.progress.unitsProgress;
          setUnitsProgress(units);

          // ELL-7749: student-facing equivalent of the teacher/admin completed-level
          // notice (see DataContainer.tsx / StudentData.tsx). The response has no
          // aggregate "totalProgressInLevel" field, so completeness is derived from
          // every unit in unitsProgress being at 100%.
          const isFullyComplete =
            units.length > 0 && units.every((unit: any) => Math.round(unit.progress) === 100);
          const allowIndividualAdvancement =
            response.data.studentData?.groupSettings?.allowIndividualAdvancement;
          setIsLevelComplete(isFullyComplete);
        }
      } catch (error) {
        console.log(error);
        commonUtils.showGlobalError({ i18nKey: 'error.somethingWentWrong' });
      }

      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!user?.progress?.userLevel) {
      return;
    }
    fetchStudentProfileProgress();
  }, [user?.progress?.userLevel]);

  return {
    isLoading,
    unitsProgress,
    isLevelComplete,
  };
};

export default UseMyProfile;
